import { PERMISSIONS } from "constants/permissions"
import { useSearchParams, useWindowSize } from "helpers/hooks"
import { hasPermission } from "helpers/permissions"
import { useAppSelector } from "hooks/useApp"
import { includes } from "lodash"
import { ActionLogPage } from "pages/action-log/ActionLogPage"
import { AddressBookPage } from "pages/address-book/AddressBookPage"
import Dashboard from "pages/dashboard/Dashboard"
import PageLayout from "pages/layout/PageLayout"
import TabItem from "pages/projects/molecules/TabItem"
import { SyncCommitComponentPage } from "pages/sync-commit-component/SyncCommitComponentPage"
import { useEffect, useState } from "react"

export const WorkspaceSettingPage = () => {
  const { isMobile } = useWindowSize()
  const userInfo = useAppSelector((state) => state.userInfo)
  const [tab, setTab] = useState<string>("general")
  const { searchParams, setSearchParams } = useSearchParams()
  const [tabs, setTabs] = useState<{ name: string; path: string }[]>([])

  useEffect(() => {
    if (!userInfo?.id) {
      return
    }
    const newTabs = [
      { name: "General", path: "general" },
      { name: "Action logs", path: "action_log" },
    ]
    if (hasPermission(userInfo, PERMISSIONS.ADDRESS_BOOK_VIEW)) {
      newTabs.push({ name: "Address book", path: "address_book" })
    }
    if (hasPermission(userInfo, PERMISSIONS.SYNC_COMMIT_COMPONENT_VIEW)) {
      newTabs.push({ name: "Sync histories", path: "sync_history" })
    }
    setTabs(newTabs)
  }, [userInfo?.id])

  useEffect(() => {
    const tabFromUrl = searchParams?.tab || "general"
    if (
      includes(
        ["general", "action_log", "address_book", "sync_history"],
        tabFromUrl
      )
    ) {
      setTab(tabFromUrl)
    } else {
      setTab("general")
      setSearchParams({ tab: "general" })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams?.tab])

  const renderHeader = () => {
    return (
      <div
        className="flex items-center  h-full px-[24px]"
        style={{
          gap: isMobile && tabs.length > 2 ? 0 : 24,
          justifyContent:
            isMobile && tabs.length > 2 ? "space-between" : "flex-start",
        }}
      >
        {tabs.map((item, index) => {
          const isActive = tab === item.path
          return (
            <div className="relative h-full flex items-center">
              <TabItem
                title={item.name}
                key={index}
                isActive={isActive}
                onClick={() => {
                  setTab(item.path)
                  setSearchParams({ tab: item.path })
                }}
              />
              {isActive ? (
                <div
                  className="absolute bottom-[-1px] left-0 right-[6px] h-[4px] bg-[#FDBE44]"
                  style={{
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                  }}
                ></div>
              ) : null}
            </div>
          )
        })}
      </div>
    )
  }
  const renderContent = () => {
    switch (tab) {
      case "general":
        return <Dashboard />
      case "action_log":
        return <ActionLogPage />
      case "address_book":
        return <AddressBookPage />
      case "sync_history":
        return <SyncCommitComponentPage />
      default:
        return null
    }
  }
  return (
    <PageLayout childrenHeader={renderHeader()} heightHeader={48}>
      {renderContent()}
    </PageLayout>
  )
}
